export class GeneralDossierConfig {
	BookYearStartMonth: number = 0;
	BookYearStartDate:number = 1;
	HideInitModal: boolean = false;
	ShowQuickStart: boolean = false;
	DefaultBankTypeID: number = 1;
	DefaultConvertSaleToCreditNoteBankTypeID:number = 1;
	DefaultCashPaymentBankTypeID:number = 9;
	DefaultSepaPaymentBankTypeID:number = 1;
	DefaultCashRoundingLedgerAccountCode:string = "499000";
	DefaultPaymentDifferenceBankTypeID:number = 8;
	UnitFieldName:string = "";
	AutoShopSynch:boolean = false;
	UseSimpleGroups:boolean = false;
	// Sale deletion notifications (array of sale type IDs to notify for)
	NotifyOwnerOnSaleDeleteTypes:number[] = [];
	EmailOwnerOnSaleDeleteTypes:number[] = [];
	SaleDeleteNotificationEmails:string = "";

	constructor(data?: any) {
		if (!data) return;
		this.BookYearStartMonth = data.BookYearStartMonth;
		this.BookYearStartDate = data.BookYearStartDate;
		this.HideInitModal = data.HideInitModal;
		this.ShowQuickStart = data.ShowQuickStart;
		this.DefaultBankTypeID = data.DefaultBankTypeID;
		this.DefaultConvertSaleToCreditNoteBankTypeID = data.DefaultConvertSaleToCreditNoteBankTypeID;
		this.DefaultCashPaymentBankTypeID = data.DefaultCashPaymentBankTypeID;
		this.DefaultSepaPaymentBankTypeID = data.DefaultSepaPaymentBankTypeID ? data.DefaultSepaPaymentBankTypeID : 1;
		this.DefaultCashRoundingLedgerAccountCode = data.DefaultCashRoundingLedgerAccountCode;
		this.DefaultPaymentDifferenceBankTypeID = data.DefaultPaymentDifferenceBankTypeID ? data.DefaultPaymentDifferenceBankTypeID : 8;
		this.UnitFieldName = data.UnitFieldName || "";
		this.AutoShopSynch = data.AutoShopSynch || false;
		this.UseSimpleGroups = data.UseSimpleGroups || false;
		this.NotifyOwnerOnSaleDeleteTypes = data.NotifyOwnerOnSaleDeleteTypes || [];
		this.EmailOwnerOnSaleDeleteTypes = data.EmailOwnerOnSaleDeleteTypes || [];
		this.SaleDeleteNotificationEmails = data.SaleDeleteNotificationEmails || "";
	}

	getJSON() {
		return {
			BookYearStartMonth: this.BookYearStartMonth,
			BookYearStartDate: this.BookYearStartDate,
			HideInitModal: this.HideInitModal,
			ShowQuickStart: this.ShowQuickStart,
			DefaultBankTypeID: this.DefaultBankTypeID,
			DefaultConvertSaleToCreditNoteBankTypeID: this.DefaultConvertSaleToCreditNoteBankTypeID,
			DefaultCashPaymentBankTypeID: this.DefaultCashPaymentBankTypeID,
			DefaultSepaPaymentBankTypeID: this.DefaultSepaPaymentBankTypeID,
			DefaultCashRoundingLedgerAccountCode: this.DefaultCashRoundingLedgerAccountCode,
			DefaultPaymentDifferenceBankTypeID: this.DefaultPaymentDifferenceBankTypeID,
			UnitFieldName: this.UnitFieldName,
			AutoShopSynch: this.AutoShopSynch,
			UseSimpleGroups: this.UseSimpleGroups,
			NotifyOwnerOnSaleDeleteTypes: this.NotifyOwnerOnSaleDeleteTypes,
			EmailOwnerOnSaleDeleteTypes: this.EmailOwnerOnSaleDeleteTypes,
			SaleDeleteNotificationEmails: this.SaleDeleteNotificationEmails
		};
	}
}